import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/build/pdf.mjs";
import PdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs?worker";

const PDF_HEADER = [0x25, 0x50, 0x44, 0x46];

let sharedWorker;

export const hasPdfHeader = (bytes) =>
  Boolean(bytes) &&
  bytes.length >= 4 &&
  bytes[0] === PDF_HEADER[0] &&
  bytes[1] === PDF_HEADER[1] &&
  bytes[2] === PDF_HEADER[2] &&
  bytes[3] === PDF_HEADER[3];

export const toPdfBytes = (data) => {
  let bytes;
  if (data instanceof Uint8Array) {
    bytes = data.slice();
  } else if (data instanceof ArrayBuffer) {
    bytes = new Uint8Array(data.slice(0));
  } else if (ArrayBuffer.isView(data)) {
    bytes = new Uint8Array(data.buffer.slice(data.byteOffset, data.byteOffset + data.byteLength));
  } else {
    throw new Error("Preview payload is not a PDF buffer");
  }

  if (!hasPdfHeader(bytes)) {
    throw new Error("Preview payload is not a PDF buffer");
  }

  return bytes;
};

export const ensurePdfWorker = () => {
  if (sharedWorker) {
    return sharedWorker;
  }

  sharedWorker = new PdfWorker();
  GlobalWorkerOptions.workerPort = sharedWorker;
  return sharedWorker;
};

export const loadPdfDocument = (data) => {
  ensurePdfWorker();
  return getDocument({
    data: toPdfBytes(data),
    isEvalSupported: false,
    enableXfa: false,
  });
};
